import {
  Box,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
  FormControlLabel,
  Switch,
  CircularProgress,
} from "@mui/material";
import RootComponents from "../../../components/common/RootComponents";
import styles from "../Candidate.module.css";
import {
  convertArrayToString,
  customTextColor,
  formatArrayString,
  formatDate,
  ShortenName2,
  splitIntoColumns,
} from "../../../utils/const";
import SubmitedCandidateProfile from "../../../components/containers/SubmitedCandidateProfile";
import { useEffect, useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { PiChairLight } from "react-icons/pi";
import { PiAddressBookLight } from "react-icons/pi";
import { PiIdentificationCardLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { PiUserLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { allSkill } from "../../../redux/common/skillSlice";
import {
  getAllCandidate,
  getAllRequirementCountForCandidate,
  getOneCandidate,
  updateActionCandidateProfile,
} from "../../../redux/candidate/candidateSlice";
import Resume from "../../../assets/images/Resume - Profile.png";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../../redux/common/locationSlice";
import { sassTrue } from "sass";
const CandidateListingDetails = () => {
  const [candidateStatus, setCandidateStatus] = useState("submitted");
  const [isExpanded, setIsExpanded] = useState(false);
  const [open, setOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [actionName, setActionName] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { row } = location.state || {};
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location) || [];
  const skillData = useSelector((state) => state.skill.data);
  const singleCandidateData = useSelector(
    (state) => state.candidate.singleCandidateData
  );

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const candidatesStatus = useSelector((state) => state.candidate.status);
  const singleCandidateStatus = useSelector(
    (state) => state.candidate.singleCandidateStatus
  );

  const [data, setData] = useState(
    location.state || JSON.parse(localStorage.getItem("candidateDetails"))
  );

  useEffect(() => {
    if (location.state) {
      localStorage.setItem("candidateDetails", JSON.stringify(location.state));
      setData(location.state);
    }
  }, [location.state]);

  useEffect(() => {
    dispatch(allSkill());
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, []);

  const handleSelect = (value) => {
    setActionName(value);
    handleOpen();
  };
  const matchingSkills = skillData?.locations?.filter((skill) =>
    data?.row?.skills?.includes(skill.id)
  );
  const columns = splitIntoColumns(matchingSkills, 4);

  const matchingSkills2 = skillData?.locations?.filter((skill) =>
    data?.row?.secondary_skills?.includes(skill.id)
  );
  const columns2 = splitIntoColumns(matchingSkills2, 4);

  useEffect(() => {
    if (singleCandidateData) {
      let quiry = singleCandidateData?.profile?.id;
      dispatch(getAllRequirementCountForCandidate(quiry));
    }
  }, [singleCandidateData]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenAction = () => {
    setOpenAction(true);
  };

  const handleCloseAction = () => {
    setOpenAction(false);
  };

  const handleOnChangeAction = (name) => {
    setActionName(name);
  };

  const handleOnClickChangeAction = () => {
    let userData = {
      active: actionName === "Active" ? true : false,
      resume_profile_id: data?.row?.id,
      candidate: data?.row?.candidate,
      full_name: data?.row?.full_name,
      prefer_tax_team: data?.row?.prefer_tax_team,
      recruiter_user_id: data?.row?.recruiter_user_id,
    };
    dispatch(updateActionCandidateProfile(userData));
  };

  useEffect(() => {
    if (candidatesStatus === "update_candidate_action") {
      dispatch(getAllCandidate());
      handleClose();
      handleCloseAction();
    }
  }, [candidatesStatus, singleCandidateData]);

  useEffect(() => {
    if (data?.row) {
      setActionName(data?.row?.job_status);
    }
  }, [data?.row]);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };
  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const whichStatus = (value) => {
    let status;
    if (value === true) {
      status = "Active";
    } else {
      status = "In-Active";
    }
    return status;
  };

  useEffect(() => {
    if (data?.row) {
      let ID = data?.row?.id;
      dispatch(getOneCandidate(ID));
    }
  }, [data?.row]);

  return (
    // <RootComponents>
    <>
      {singleCandidateStatus === "loading" ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 230,
          }}
        >
          <CircularProgress size={30} color="info" />
        </Box>
      ) : (
        <Box className={styles.candidate_structure}>
          <Box className={styles.job_serach_result_heading}>
            <Typography>
              Activities Since:{" "}
              <b>
                {singleCandidateData?.profile?.created_at !== undefined &&
                  formatDate(singleCandidateData?.profile?.created_at)}
              </b>
            </Typography>
          </Box>

          <Box className={styles.profile_and_submit}>
            <Box>
              <Typography>
                <b>Profile Credited by</b>
              </Typography>
            </Box>
            <a
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                textDecoration: "none",
                color: "#374151",
              }}
              href={singleCandidateData?.profile?.resume}
              target="_blank"
            >
              <Box className={styles.phase2}>
                <img
                  src={Resume}
                  alt="attachment"
                  style={{
                    width: "50px",
                    backgroundColor: "#e1eaf0",
                    padding: "6px",
                    borderRadius: "3px",
                  }}
                />
                <Typography sx={{ marginTop: "5px" }}>Get Resume</Typography>
              </Box>
            </a>
          </Box>
          <Grid container className={styles.profile_phase}>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              sx={{ border: "none !important" }}
            >
              <Typography sx={{ marginLeft: "0 !important" }}>
                <PiUserLight
                  style={{
                    fontSize: "33px",
                    backgroundColor: "#bed7ed",
                    padding: "4px",
                    borderRadius: "3px",
                    color: "#4c68b0",
                  }}
                />

                <b style={{ marginLeft: "10px" }}>
                  {" "}
                  {singleCandidateData?.profile?.full_name}
                </b>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Typography>
                {" "}
                <PiChairLight
                  style={{
                    fontSize: "33px",
                    backgroundColor: "#bed7ed",
                    padding: "4px",
                    borderRadius: "3px",
                    color: "#4c68b0",
                  }}
                />
                <b style={{ marginLeft: "10px" }}>
                  {ShortenName2(
                    singleCandidateData?.profile?.current_job_title
                  )}{" "}
                </b>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Typography>
                <PiAddressBookLight
                  style={{
                    fontSize: "33px",
                    backgroundColor: "#bed7ed",
                    padding: "4px",
                    borderRadius: "3px",
                    color: "#4c68b0",
                  }}
                />

                <b style={{ marginLeft: "10px" }}>
                  {singleCandidateData?.profile?.total_experience} Years’
                  Experience
                </b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              sx={{ color: customTextColor }}
            >
              <Typography>
                <PiIdentificationCardLight
                  style={{
                    fontSize: "33px",
                    backgroundColor: "#bed7ed",
                    padding: "4px",
                    borderRadius: "3px",
                    color: "#4c68b0",
                  }}
                />

                <b style={{ marginLeft: "10px" }}>
                  {getWorkAuthorization(
                    singleCandidateData?.profile?.work_authorization
                  )}
                </b>
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            className={styles.profile_details_view}
            sx={{ color: customTextColor, margiTop: "10px" }}
          >
            <Grid
              item
              md={6}
              lg={6}
              sx={{ display: "block !important" }}
              className={styles.profile_details_views}
            >
              <ul
                style={{
                  listStyleType: "square",
                  padding: "5px 20px",
                  marginBottom: "10px",
                }}
              >
                <Box>
                  <li>
                    <Typography>
                      Current Location:{" "}
                      <b>
                        {getLocationById(
                          singleCandidateData?.profile?.current_location
                        )}
                      </b>
                    </Typography>
                  </li>
                </Box>
                <Box>
                  <li>
                    <Typography>
                      Tax Term:{" "}
                      <b>
                        {formatArrayString(
                          singleCandidateData?.profile?.p_tax_team
                        )}
                      </b>
                    </Typography>
                  </li>
                </Box>

                <Box>
                  <li>
                    <Typography>
                      Work Preference:{" "}
                      <b>{singleCandidateData?.profile?.work_preference}</b>
                    </Typography>
                  </li>
                </Box>

                <Box>
                  <li>
                    <Typography>
                      Passing Year:{" "}
                      <b>{singleCandidateData?.profile?.passing_year}</b>
                    </Typography>
                  </li>
                </Box>

                <Box sx={{ marginBottom: "0 !important" }}>
                  <li>
                    <Typography>
                      Qualifications:{" "}
                      <b>
                        {" "}
                        {
                          singleCandidateData?.profile?.highest_qualification
                        }{" "}
                      </b>
                    </Typography>
                  </li>
                </Box>
              </ul>
            </Grid>

            <Grid
              item
              md={6}
              lg={6}
              sx={{ display: "block !important" }}
              className={styles.profile_details_views}
            >
              <ul
                style={{
                  listStyleType: "square",
                  padding: "5px 20px",
                  marginBottom: "10px",
                }}
              >
                <Box>
                  <li>
                    <Typography>
                      Prefer Location:{" "}
                      <b>
                        {getPreferLocationNames(
                          singleCandidateData?.profile?.prefer_location
                        )}
                      </b>
                    </Typography>
                  </li>
                </Box>
                <Box>
                  <li>
                    <Typography>
                      Rate:{" "}
                      <b> ${singleCandidateData?.profile?.rate} Hourly </b>
                    </Typography>
                  </li>
                </Box>

                <Box>
                  <li>
                    <Typography>
                      Current Organization:
                      <b>{singleCandidateData?.profile?.current_company}</b>
                    </Typography>
                  </li>
                </Box>

                <Box>
                  <li>
                    <Typography>
                      University:
                      <b> {singleCandidateData?.profile?.university} </b>
                    </Typography>
                  </li>
                </Box>
                <Box sx={{ marginBottom: "0 !important" }}>
                  <li>
                    <Typography>
                      Linked in Profile:{" "}
                      <b>
                        {" "}
                        {singleCandidateData?.profile?.linkedin_profile_url}
                      </b>
                    </Typography>
                  </li>
                </Box>
              </ul>
            </Grid>
          </Grid>

          <Grid container sx={{ backgroundColor: "#fff", margin: "14px 0" }}>
            <Grid item xs={12}>
              <Box className={styles.list_details}>
                <Typography sx={{ marginBottom: "20px !important" }}>
                  <b>Primary skills</b>
                </Typography>
                <Grid container sx={{ fontWeight: "600" }}>
                  {columns.map((column, colIndex) => (
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={3}
                      lg={3}
                      key={colIndex}
                      sx={{
                        borderLeft: colIndex !== 0 ? "2px solid white" : "none",
                        paddingLeft: colIndex !== 0 ? "20px" : "0",
                      }}
                    >
                      <Box sx={{ color: customTextColor }}>
                        {column.map((skill) => (
                          <Typography
                            key={skill.id}
                            sx={{ marginBottom: "0 !important" }}
                          >
                            {skill.name}
                          </Typography>
                        ))}
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>
          </Grid>

          <Grid container sx={{ backgroundColor: "#fff", margin: "14px 0" }}>
            <Grid item xs={12}>
              <Box className={styles.list_details}>
                <Typography sx={{ marginBottom: "20px !important" }}>
                  <b>Secondary skills</b>
                </Typography>
                <Grid container sx={{ fontWeight: "600" }}>
                  {columns2.map((column, colIndex) => (
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={3}
                      lg={3}
                      key={colIndex}
                      sx={{
                        borderLeft: colIndex !== 0 ? "2px solid white" : "none",
                        paddingLeft: colIndex !== 0 ? "20px" : "0",
                      }}
                    >
                      <Box sx={{ color: customTextColor }}>
                        {column.map((skill) => (
                          <Typography
                            key={skill.id}
                            sx={{ marginBottom: "0 !important" }}
                          >
                            {skill.name}
                          </Typography>
                        ))}
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>
          </Grid>
          <Box className={styles.experience_details}>
            <Box>
              <Typography sx={{ fontSize: "18px !important" }}>
                <b>Professional Experience</b>
              </Typography>
            </Box>
          </Box>
          {singleCandidateData?.profile?.previous_experience ? (
            JSON?.parse(singleCandidateData?.profile?.previous_experience)?.map(
              (prevData, index) => {
                return (
                  <Box className={styles.full_details}>
                    <Box sx={{ marginLeft: "20px" }}>
                      <Typography>
                        <b>{prevData?.role}</b>
                      </Typography>
                      <Typography>{prevData?.company}</Typography>
                      <Typography>
                        {prevData?.industry_of_the_company}
                      </Typography>
                      <Typography
                        sx={{
                          display: "flex",
                          justifyContent: "end",
                          position: "relative",
                          bottom: "60px",
                        }}
                      >
                        {prevData?.duration_from} to {prevData?.duration_to}
                      </Typography>
                    </Box>
                    <ul>
                      {prevData?.summary_of_work.map((text, index) => (
                        <li key={index}>{text}</li>
                      ))}
                    </ul>
                  </Box>
                );
              }
            )
          ) : (
            <p>No Experience Found</p>
          )}

          {/* <Box className={styles.full_details}>
                <Box sx={{ marginLeft: "20px" }}>
                  <Typography>
                    <b>Sr. Full Stack Java Developer </b>
                  </Typography>
                  <Typography>HSBC, Hyderabad, India </Typography>
                  <Typography>Domain: Healthcare </Typography>
                  <Typography
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                      position: "relative",
                      bottom: "60px",
                    }}
                  >
                    Feb 2021 to July 2022
                  </Typography>
                </Box>
                <ul>
                  <li>
                    <Typography>
                      Designed the project using MVC, Service Locator and Business
                      Delegate patterns.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      Followed agile methodology, interacted with the client,
                      provide/take feedback on the features, suggest/implement optimal
                      solutions and tailored application to customer needs.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      Integrated the application with Spring Framework for
                      implementing Dependency Injection and provide abstraction
                      between presentation layer and persistence layer.
                    </Typography>
                  </li>
                  <li>
                    <Typography>
                      Developed Web pages using Struts view component JSP, JavaScript,
                      HTML, jQuery, AJAX, to create the user interface views Migration
                      3rd party applications.
                    </Typography>
                  </li>
                  {selectMore && (
                    <>
                      <li>
                        <Typography>
                          Used Hibernate ORM framework as persistence engine,
                          configured O/R mapping and wrote hibernate queries.
                        </Typography>
                      </li>
                      <li>
                        <Typography>
                          Involved in designing front-end screens using Java script,
                          JSP, Angular JS, AJAX, HTML5 and DHTML.
                        </Typography>
                      </li>
                      <li>
                        <Typography>
                          Designed and integrated the full scale Hibernate / spring.
                        </Typography>
                      </li>
                      <li>
                        <Typography>
                          Configured and deployed the application on WebLogic
                          Application Server.
                        </Typography>
                      </li>
                    </>
                  )}
                  <Box className={styles.read_details}>
                    <Box onClick={handleSelect}>
                      <Typography>
                        <b>{selectMore ? "Read Less" : "Read More"}</b>
                      </Typography>
                    </Box>
                  </Box>
                </ul>
              </Box> */}
          {singleCandidateData?.profile?.referrer_company_name === "" &&
          singleCandidateData?.profile?.referrer_email === "" &&
          singleCandidateData?.profile?.referrer_manager_name === "" &&
          singleCandidateData?.profile?.referrer_mobile_no === "" ? (
            ""
          ) : (
            <Grid
              container
              className={styles.candidates_name}
              sx={{ marginBottom: "14px" }}
            >
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Grid
                  container
                  className={styles.requirement_details_view}
                  sx={{ color: customTextColor }}
                >
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <span>
                      <Box>
                        <PiUserLight
                          style={{
                            fontSize: "33px",
                            backgroundColor: "#d9d9d9",
                            padding: "4px",
                            borderRadius: "3px",
                          }}
                        />
                        <Typography>
                          Manager Name:{" "}
                          <b>
                            {
                              singleCandidateData?.profile
                                ?.referrer_manager_name
                            }
                          </b>
                        </Typography>
                      </Box>
                      <Box sx={{ marginBottom: "0 !important" }}>
                        <PiMailboxLight
                          style={{
                            fontSize: "33px",
                            backgroundColor: "#d9d9d9",
                            padding: "4px",
                            borderRadius: "3px",
                          }}
                        />
                        <Typography>
                          Email ID :
                          <b>
                            {" "}
                            {singleCandidateData?.profile?.referrer_email}{" "}
                          </b>
                        </Typography>
                      </Box>
                    </span>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <span>
                      <Box>
                        <PiBuildingOfficeLight
                          style={{
                            fontSize: "33px",
                            backgroundColor: "#d9d9d9",
                            padding: "4px",
                            borderRadius: "3px",
                          }}
                        />
                        <Typography>
                          Company Name:{" "}
                          <b>
                            {
                              singleCandidateData?.profile
                                ?.referrer_company_name
                            }
                          </b>
                        </Typography>
                      </Box>

                      <Box sx={{ marginBottom: "0 !important" }}>
                        <CiMobile3
                          style={{
                            fontSize: "33px",
                            backgroundColor: "#d9d9d9",
                            padding: "4px",
                            borderRadius: "3px",
                          }}
                        />
                        <Typography>
                          Phone No:{" "}
                          <b>
                            {singleCandidateData?.profile?.referrer_mobile_no}{" "}
                          </b>
                        </Typography>
                      </Box>
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          {singleCandidateData?.profile?.referrer_company_name2 === "" &&
          singleCandidateData?.profile?.referrer_email2 === "" &&
          singleCandidateData?.profile?.referrer_manager_name2 === "" &&
          singleCandidateData?.profile?.referrer_mobile_no2 === "" ? (
            ""
          ) : (
            <Grid
              container
              className={styles.candidates_name}
              sx={{ marginBottom: "14px" }}
            >
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Grid
                  container
                  className={styles.requirement_details_view}
                  sx={{ color: customTextColor }}
                >
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <span>
                      <Box>
                        <PiUserLight
                          style={{
                            fontSize: "33px",
                            backgroundColor: "#d9d9d9",
                            padding: "4px",
                            borderRadius: "3px",
                          }}
                        />
                        <Typography>
                          Manager Name:{" "}
                          <b>
                            {
                              singleCandidateData?.profile
                                ?.referrer_manager_name2
                            }
                          </b>
                        </Typography>
                      </Box>
                      <Box sx={{ marginBottom: "0 !important" }}>
                        <PiMailboxLight
                          style={{
                            fontSize: "33px",
                            backgroundColor: "#d9d9d9",
                            padding: "4px",
                            borderRadius: "3px",
                          }}
                        />
                        <Typography>
                          Email ID :
                          <b>
                            {" "}
                            {singleCandidateData?.profile?.referrer_email2}{" "}
                          </b>
                        </Typography>
                      </Box>
                    </span>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <span>
                      <Box>
                        <PiBuildingOfficeLight
                          style={{
                            fontSize: "33px",
                            backgroundColor: "#d9d9d9",
                            padding: "4px",
                            borderRadius: "3px",
                          }}
                        />
                        <Typography>
                          Company Name:{" "}
                          <b>
                            {
                              singleCandidateData?.profile
                                ?.referrer_company_name2
                            }
                          </b>
                        </Typography>
                      </Box>

                      <Box sx={{ marginBottom: "0 !important" }}>
                        <CiMobile3
                          style={{
                            fontSize: "33px",
                            backgroundColor: "#d9d9d9",
                            padding: "4px",
                            borderRadius: "3px",
                          }}
                        />
                        <Typography>
                          Phone No:{" "}
                          <b>
                            {singleCandidateData?.profile?.referrer_mobile_no2}{" "}
                          </b>
                        </Typography>
                      </Box>
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          <Box className={styles.internal_update_btns}>
            <Box className={styles.add_back_btns}>
              <button
                onClick={() => navigate(-1)}
                style={{
                  border: "1.5px solid #4285f4",
                  marginRight: "10px",
                  padding: "4.5px 10px ",
                }}
              >
                <IoIosArrowRoundBack
                  style={{ fontSize: "25px", color: "#4285f4" }}
                />
              </button>
            </Box>
            <Box>
              {/* <button
                    style={{ backgroundColor: "#3856a6", marginRight: "0" }}
                    onClick={handleOpenAction}
                  >
                    Update Status
                  </button> */}
              {/* <FormControlLabel
                    control={<Switch onChange={handleOpen} />}
                    label={singleCandidateData?.profile?.active ? "In-Active" : "Active"}
                  /> */}
              {/* <button
                    style={{ backgroundColor: "#3856a6 ", padding: "7.5px 15px " }}
                    // onClick={() => navigate("/internal-tracker-add")}
                  >
                    Update Status
                  </button> */}

              <div className="btn-group">
                <button
                  type="button"
                  className="dropdown-toggle"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{
                    color: "black",
                    width: "7rem",
                    border: "1.5px solid #4287f5",
                    padding: "6px 10px",
                  }}
                >
                  {whichStatus(actionName)}
                </button>
                <div className="dropdown-menu">
                  <a
                    className="dropdown-item"
                    style={{ backgroundColor: "#fff" }}
                    onClick={() => handleSelect(true)}
                  >
                    Active
                  </a>
                  <a
                    className="dropdown-item"
                    style={{ backgroundColor: "#fff" }}
                    onClick={() => handleSelect(false)}
                  >
                    In-Active
                  </a>
                </div>
              </div>
            </Box>
          </Box>
          {/* <Box className={styles.view_update_btns}>
                <button style={{ backgroundColor: "#aabee4" }}>
                  View Resume (2)
                </button>
                <Box>
                  <button
                    style={{
                      backgroundColor: "#00b050 ",
                      padding: "20px 30px !important",
                    }}
                  >
                    Check Availability
                  </button>
                </Box>
              </Box>
              <Grid container>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3}
                  lg={3}
                  sx={{ padding: "20px 20px 20px 0" }}
                >
                  <Box
                    className={styles.student_status_tab}
                    sx={
                      candidateStatus === "submitted"
                        ? { backgroundColor: "#d9d9d9 !important" }
                        : { color: customTextColor }
                    }
                    onClick={() => setCandidateStatus("submitted")}
                  >
                    <b style={{ fontSize: "22px" }}>25 </b> Submitted
                  </Box>
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} sx={{ padding: "20px" }}>
                  <Box
                    className={styles.student_status_tab}
                    sx={
                      candidateStatus === "interviewed"
                        ? { backgroundColor: "#d9d9d9 !important" }
                        : { color: customTextColor }
                    }
                    onClick={() => setCandidateStatus("interviewed")}
                  >
                    <b style={{ fontSize: "22px" }}>10 </b> Interviewed
                  </Box>
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} sx={{ padding: "20px" }}>
                  <Box
                    className={styles.student_status_tab}
                    sx={
                      candidateStatus === "shortlisted"
                        ? { backgroundColor: "#d9d9d9 !important" }
                        : { color: customTextColor }
                    }
                    onClick={() => setCandidateStatus("shortlisted")}
                  >
                    <b style={{ fontSize: "22px" }}>05 </b> Shortlisted
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3}
                  lg={3}
                  sx={{ padding: "20px 0 20px 20px" }}
                >
                  <Box
                    className={styles.student_status_tab}
                    sx={
                      candidateStatus === "offerlatter"
                        ? { backgroundColor: "#d9d9d9 !important" }
                        : { color: customTextColor }
                    }
                    onClick={() => setCandidateStatus("offerlatter")}
                  >
                    <b style={{ fontSize: "22px" }}>01 </b> Offer Latter
                  </Box>
                </Grid>
              </Grid>
      
              <Box>
                <SubmitedCandidateProfile
                  name="Java Developer"
                  skill=": Dallas Taxes, TX"
                  client=": Master Card"
                  submission="12 May 2024"
                  btn="View"
                />
                <SubmitedCandidateProfile
                  name="Full Stack Java Developer"
                  skill="New York, NY"
                  client="Human Healthcare"
                  submission="10 May 2024"
                  btn="View"
                />
              </Box> */}
          <Box className={styles.send_update_btns}>
            {/* <button
                    onClick={() =>
                      navigate("/jobpost/add", {
                        state: { row: row, type: "republis" },
                      })
                    }
                    style={{ marginLeft: "15px", backgroundColor: "#4285f4" }}
                  >
                    Republish
                  </button> */}
            <Box>
              {/* <span className={styles.new_update_btns}>
                    <button
                      style={{ backgroundColor: "#3856a6", marginRight: "0" }}
                      onClick={handleOpenAction}
                    >
                      Action
                    </button>
                  </span> */}
            </Box>
          </Box>
        </Box>
      )}

      <Dialog
        fullScreen={fullScreen}
        open={openAction}
        // onClose={handleCloseAction}
        maxWidth="md"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogContent sx={{ display: "flex", justifyContent: "center" }}>
            <Box>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios1"
                  value="Active"
                  checked={singleCandidateData?.profile?.active === true}
                  onChange={() => handleOnChangeAction("Active")}
                />
                <label class="form-check-label" for="exampleRadios1">
                  Active
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios2"
                  value="InActive"
                  checked={singleCandidateData?.profile?.active === false}
                  onChange={() => handleOnChangeAction("InActive")}
                />
                <label class="form-check-label" for="exampleRadios2">
                  InActive
                </label>
              </div>
            </Box>
          </DialogContent>
          <Box>
            <Box className={styles.adding_internal_btns}>
              <button
                sx={{ backgroundColor: "#2d73b5" }}
                // onClick={handleOnClickStatusChange}
                onClick={handleOpen}
              >
                Change
              </button>
              <button
                sx={{ backgroundColor: "#97B6F1" }}
                onClick={handleCloseAction}
              >
                Cancel
              </button>
            </Box>
          </Box>
        </Box>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        // onClose={handleClose}
        maxWidth="md"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ textAlign: "center" }}
          >
            <b>Job Action Change</b>
          </DialogTitle>
          <DialogContent sx={{ textAlign: "center" }}>
            Are you sure you want to change action to{" "}
            {actionName ? "Active" : "In-Active"}
          </DialogContent>
          <Box>
            <Box className={styles.adding_internal_btns}>
              <button
                sx={{ backgroundColor: "#2d73b5" }}
                // onClick={handleOnClickStatusChange}
                onClick={handleOnClickChangeAction}
              >
                Yes
              </button>
              <button sx={{ backgroundColor: "#97B6F1" }} onClick={handleClose}>
                No
              </button>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
    // </RootComponents>
  );
};

export default CandidateListingDetails;
